import { Page } from '../../../../models/page';

export class PreviewPages {

    pages: Array<Page>;
    id: number;

}
